import React, { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';

import LoadingOverlay from 'react-loading-overlay';
import FadeLoader from 'react-spinners/FadeLoader';
LoadingOverlay.propTypes = undefined;

// Lazy load components for better performance
const OrganisationList = lazy(() => import('../Organization/Organization'));
const SupportUserList = lazy(() => import('../SupportUser/SupportUser'));
const AdminUserList = lazy(() => import('../Users/Pages/User/Users'));

/**
 * Store module routes
 * @param {Object} props - Component props
 * @returns {JSX.Element} - Store routes
 */
const HomeRoute = (props) => {
    const { history } = props;

    return (
        <>
            <Route
                exact
                path="/:lng/home/organisation"
                render={() => (
                    <Suspense fallback={<Loading />}>
                        <OrganisationList history={history} />
                    </Suspense>
                )}
            />
            <Route
                exact
                path="/:lng/home/support_user"
                render={() => (
                    <Suspense fallback={<Loading />}>
                        <SupportUserList history={history} />
                    </Suspense>
                )}
            />
            <Route
                exact
                path="/:lng/home/admin"
                render={() => (
                    <Suspense fallback={<Loading />}>
                        <AdminUserList history={history} />
                    </Suspense>
                )}
            />
        </>
    );
};
function Loading() {
    return (
        <>
            <div className="wrapper">
                <span>Loading</span>
            </div>
        </>
    );
}
export default HomeRoute;
